import { setElementHtml } from '../../../../../helpers/generic-js/dom.js'
import { inviteCreate } from './invite-create.js'
import htmlInviteCreate from './invite-create.html'

export function showCreateInvite (params) {
  const { browserAppAccount, create } = params
  const { containerElementId } = create

  const containerElement = setElementHtml(containerElementId, htmlInviteCreate)

  addListener(containerElement, browserAppAccount)
}

function addListener (parentElement, browserAppAccount) {
  const formElement = parentElement.querySelector('form')
  if (!formElement) return

  /**
    * Should work on Enter, and button click
  */
  formElement.addEventListener('submit', async function (submitEvent) {
    console.log('form submitEvent', submitEvent)
    submitEvent.preventDefault()

    await inviteCreate(browserAppAccount)

    // Inform the parent module
    parentElement.dispatchEvent(new Event('inviteCreated'))
  })
}
